// extracted by mini-css-extract-plugin
export default {"img":"back_image_img__57Bha","overlay":"back_image_overlay__ejMNY"};